"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.shared.yes': 'Tak',
    'step.shared.no': 'Nie',
};
